import type { ReactNode } from 'react';

export const symbol_folder_info: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-220v-520 250-39 309Zm0 60q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h281l60 60h339q23 0 41.5 18.5T880-680v186q0 13.08-8.68 21.54-8.67 8.46-21.5 8.46-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-186H456l-60-60H140v520h278q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm683.5-251.5Q880-355 880-274t-56.5 137.5Q767-80 686-80t-137.5-56.5Q492-193 492-274t56.5-137.5Q605-468 686-468t137.5 56.5ZM700-160q6-6 6-14v-120q0-8-6-14t-14-6q-8 0-14 6t-6 14v120q0 8 6 14t14 6q8 0 14-6Zm0-200q6-6 6-14t-6-14q-6-6-14-6t-14 6q-6 6-6 14t6 14q6 6 14 6t14-6Z"
		/>
	</svg>
);
